import {
  Component,
  Input,
  Output,
  ElementRef,
  HostListener,
  ViewChildren,
  QueryList,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import {
  SafeResourceUrl,
  DomSanitizer,
  SafeHtml,
} from '@angular/platform-browser';

import Swal from 'sweetalert2';
import { ChangeDetectorRef } from '@angular/core';
import { NgZone } from '@angular/core';
import { toApiDate } from '../CommonFunctions/date-utils';

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class BookingComponent {
  hideCoverageDropdown = false;
  isReginaLifeMode = false;
  isSubmitting = false;
  showFullPageLoader = false;
  dynamicForm!: FormGroup;
  selectedResource: any;
  filteredFields: any[] = [];
  @Input() signaturePadOptions: any;
  @Input() customerData: any;
  @Input() typeOfForm!: string;
  @Input() eligibilityMap!: any;
@Input() apiUrl!: string;
@Input() authorizeApiUrl!: string;



  sanitizedFormUrl: SafeResourceUrl | null = null;
  dummyResources: any[] = [];
  signatureImage: string = '';
  bookingInformation: any[] = [];
  modalContent!: SafeHtml;
  showSpouse: boolean = false;
  showDependent: boolean = false;
  bookingFor: string[] = [];
  coverageField: any;
  childrenField: any;
  coverageOptions: any[] = [];
  selectedCoverage: string[] = [];
  selectedMembers: string[] = [];
  selectedMapUrl: SafeResourceUrl | null = null;
currentCoverageType: 'self' | 'spouse' | 'both' | 'children' | string | null = null;

  isDrawing = false;
  signaturecheckvalue1cc: any;
  showupdatesignatue: boolean = true;
  disableOrderButton: boolean = false;
  nextAvailableDate: string | null = null;
  lastOrdered: string | null = null;
  eligibilityMessage: string = '';
   groupedClinics: Record<string, any[]> = {};
groupedClinicsArray: { key: string; value: any[] }[] = [];
private useNewCard = false;

  @ViewChildren('sigPad') sigPads!: QueryList<ElementRef<HTMLCanvasElement>>;
  @HostListener('document:mouseup', ['$event'])
  @Output()
  eligibilityUpdated = new EventEmitter<any>();
  @Output() bookingCreated = new EventEmitter<{
    customerId: number;
    typeOfForm: string;
    coverageType: 'self' | 'spouse' | 'both' | 'children';
  }>();

  private contexts: { [key: string]: CanvasRenderingContext2D } = {};
  private drawing: { [key: string]: boolean } = {};
  drawingMap: Record<string, boolean> = {};
  context: CanvasRenderingContext2D | null = null;
  bookingForm: any;
  fields: any;
  currentFormFields: any[] = [];
  modalTitle: string = '';
  dependents: any = {};
  canOrder: boolean = true;
  uiCoverageLabels: string[] = [];
  modalEligibility:any;
  isExternalRedirect = false;
  
redirectUrl: string | null = null;


  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}



onCoverageUiChange(
  type: 'self' | 'spouse' | 'both',
  event: Event,
  dropdownBtn: HTMLElement
) {
  const checked = (event.target as HTMLInputElement).checked;
  if (!checked) return;

  let values: string[] = [];
  let labels: string[] = [];

  if (type === 'both') {
    values = ['self', 'spouse'];
    labels = ['Both'];
  } else {
    values = [type];
    labels = [type === 'self' ? 'Self' : 'Spouse'];
  }

  this.dynamicForm.get('coverageType')?.setValue(values);
  this.uiCoverageLabels = labels;

  dropdownBtn.click();
}




isCoverageOrdered(coverage: 'self' | 'spouse' | 'both'): boolean {
  const key = this.typeOfForm?.trim().toLowerCase();
  const e = this.eligibilityMap?.[key];

  if (!e) return false;

  if (coverage === 'both') {
    return e.self?.canOrder === false && e.spouse?.canOrder === false;
  }

  return e[coverage]?.canOrder === false;
}

isCoverageChecked(coverage: 'self' | 'spouse' | 'both'): boolean {
  return this.isCoverageOrdered(coverage);
}



hasSpouseInfo(): boolean {
  const spouse = this.customerData?.dependents?.spouseInfo;
  return !!(spouse?.firstName || spouse?.lastName);
}
isChildCoverageSelected(): boolean {
  const coverage = this.dynamicForm?.get('coverageType')?.value;
  if (Array.isArray(coverage)) {
    return coverage.some((c: any) => typeof c === 'string' && c.startsWith('child_'));
  }
  return typeof coverage === 'string' && coverage.startsWith('child_');
}

  isReadOnlyField(fieldName: string): boolean {
    const readOnlyFields = [
      'fullName',
      'firstName',
      'lastName',
      'email',
      'company',
      'dateOfBirth',
      'phone',
      'spouseLastName',
      'spouseFirstName',
      'spouseDob',
      'spouseEmail',
      'spouseGender',
      'contractNumber',
    ];
    return readOnlyFields.includes(fieldName);
  }

  getErrorMessage(fieldName: string, fieldType?: string): string {
    const control = this.dynamicForm.get(fieldName);
    if (!control) return '';
    if (control.hasError('requiredTrue')) {
      return 'You must check this box to proceed.';
    }
    if (control.hasError('required')) {
      if (fieldName.toLowerCase().includes('consent')) {
        return 'You must check this box to proceed.';
      }
      if (
        fieldType === 'signature' ||
        fieldName.toLowerCase().includes('signature')
      ) {
        return 'Signature is required before submitting.';
      }
      if (fieldType === 'option-group' || fieldType === 'select') {
        return 'Please select an option.';
      }
      return 'This field is required.';
    }
    if (control.hasError('email')) {
      return 'Please enter a valid email address.';
    }
    if (control.hasError('minlength')) {
      return `Minimum ${
        control.getError('minlength').requiredLength
      } characters required.`;
    }

    if (control.hasError('maxlength')) {
      return `Maximum ${
        control.getError('maxlength').requiredLength
      } characters allowed.`;
    }

    return '';
  }
  selectedCoverages: Set<'self' | 'spouse' | 'both'> = new Set();



  ngOnInit() {
    this.dynamicForm = this.formBuilder.group({
      coverageType: [],
    });
    this.dynamicForm
      .get('coverageType')
      ?.valueChanges.subscribe((value: string[] | string) => {
        const selected = Array.isArray(value) ? value : [value];
      });

    setTimeout(() => {
      const initialCoverage = this.dynamicForm.get('coverageType')?.value || [];
      const selectedInitial = Array.isArray(initialCoverage)
        ? initialCoverage
        : [initialCoverage];
    }, 0);
  }




  get childrens(): FormArray {
    return this.dynamicForm.get('childrens') as FormArray;
  }
  addChild() {
    const group: FormGroup = this.formBuilder.group({});
    this.childrenField.fields.forEach((f: any) => {
      group.addControl(
        f.name,
        this.formBuilder.control('', f.required ? Validators.required : [])
      );
    });
    this.childrens.push(group);
  }

shouldShowField(field: any): boolean {
  if (!field.showIf) return true;
  const controlValue = this.dynamicForm.get(field.showIf.field)?.value;

  if (field.showIf.value === 'children') {
    const hasChildSelection = Array.isArray(controlValue)
      ? controlValue.some((v: any) => typeof v === 'string' && v.startsWith('child_'))
      : typeof controlValue === 'string' && controlValue.startsWith('child_');
    if (hasChildSelection) return true;
  }

  if (Array.isArray(controlValue)) {
    return controlValue.includes(field.showIf.value);
  }
  return controlValue === field.showIf.value;
}

  get dependants(): FormArray {
    return this.dynamicForm?.get('dependants') as FormArray;
  }

  removeChild(index: number) {
    this.childrens.removeAt(index);
  }

  ngAfterViewInit() {
    const resourceModalEl = document.getElementById('resourceModal');
    if (resourceModalEl) {
      resourceModalEl.addEventListener('shown.bs.modal', () => {
        console.log(
          'Modal shown — initializing signature canvases and validators'
        );
        setTimeout(() => {
          this.refreshContexts();
          this.applyDynamicValidators();
        }, 300);
      });
    }
    setTimeout(() => {
      this.refreshContexts();
      this.applyDynamicValidators();
    }, 300);

    this.sigPads.changes.subscribe(() => {
      console.log('sigPads changed — refreshing contexts...');
      setTimeout(() => {
        this.refreshContexts();
        this.applyDynamicValidators();
      }, 300);
    });
  }
  private applyDynamicValidators() {
    const updateValidators = (selected: string[]) => {
const hasSelf = selected.includes('self');
const hasSpouse = selected.includes('spouse');
const hasChildCoverage = selected.some((s: any) => typeof s === 'string' && s.startsWith('child_'));

const consentCtrl = this.dynamicForm.get('consent');
const spouseConsentCtrl = this.dynamicForm.get('spouseConsent');
const signatureCtrl = this.dynamicForm.get('signature');
const spouseSignatureCtrl = this.dynamicForm.get('spouseSignature');
if (hasSelf || hasChildCoverage) {
  consentCtrl?.setValidators([Validators.requiredTrue]);
  signatureCtrl?.setValidators([Validators.required]);
} else {
        consentCtrl?.clearValidators();
        consentCtrl?.reset();
        consentCtrl?.markAsPristine();
        consentCtrl?.markAsUntouched();

        signatureCtrl?.clearValidators();
        signatureCtrl?.reset();
        signatureCtrl?.markAsPristine();
        signatureCtrl?.markAsUntouched();
      }
const spouseEmailCtrl = this.dynamicForm.get('spouseEmail');
if (hasSpouse) {
  spouseConsentCtrl?.setValidators([Validators.requiredTrue]);
  spouseSignatureCtrl?.setValidators([Validators.required]);
  spouseEmailCtrl?.setValidators([Validators.email]);
} else {
  spouseConsentCtrl?.clearValidators();
  spouseConsentCtrl?.reset();
  spouseConsentCtrl?.markAsPristine();
  spouseConsentCtrl?.markAsUntouched();

  spouseSignatureCtrl?.clearValidators();
  spouseSignatureCtrl?.reset();
  spouseSignatureCtrl?.markAsPristine();
  spouseSignatureCtrl?.markAsUntouched();

  spouseEmailCtrl?.clearValidators();
  spouseEmailCtrl?.updateValueAndValidity({ emitEvent: false });
}
spouseEmailCtrl?.updateValueAndValidity({ emitEvent: false });

      consentCtrl?.updateValueAndValidity({ emitEvent: false });
      spouseConsentCtrl?.updateValueAndValidity({ emitEvent: false });
      signatureCtrl?.updateValueAndValidity({ emitEvent: false });
      spouseSignatureCtrl?.updateValueAndValidity({ emitEvent: false });
      spouseEmailCtrl?.updateValueAndValidity({ emitEvent: false });
      console.log('Coverage selected:', selected);
      console.log('Consent required:', !!consentCtrl?.validator);
      console.log(' Spouse consent required:', !!spouseConsentCtrl?.validator);
    };

    this.dynamicForm
      .get('coverageType')
      ?.valueChanges.subscribe((value: string[] | string) => {
        const selected = Array.isArray(value) ? value : [value];
        updateValidators(selected);
      });
    setTimeout(() => {
      const value = this.dynamicForm.get('coverageType')?.value || [];
      const selected = Array.isArray(value) ? value : [value];
      updateValidators(selected);
    }, 0);
  }

  private refreshContexts() {
    this.contexts = {};
    this.drawing = {};
    const signatureFields = (this.selectedResource?.fields || []).filter(
      (f: any) => f.type === 'signature'
    );

    const ratio = window.devicePixelRatio || 1;

    this.sigPads.forEach((sigPad) => {
      const canvas = sigPad.nativeElement as HTMLCanvasElement;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      canvas.width = width * ratio;
      canvas.height = height * ratio;
      ctx.scale(ratio, ratio);
      ctx.strokeStyle = 'black';
      ctx.lineWidth = 2;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      const fieldName = canvas.id;
      if (fieldName && signatureFields.some((f) => f.name === fieldName)) {
        this.contexts[fieldName] = ctx;
        this.drawing[fieldName] = false;
        console.log(` Context ready for ${fieldName}`);
      } else {
        console.warn(` No matching field found for canvas id: ${canvas.id}`);
      }
      ctx.clearRect(0, 0, width, height);
    });
  }

  openPolicy(type: string) {
    if (type === 'privacy') {
      this.modalTitle = 'Privacy Policy';
      this.modalContent = this.sanitizer.bypassSecurityTrustHtml(
        `<iframe src="https://www.phzio.com/privacy" width="100%" height="400px" style="border:0;"></iframe>`
      );
    } else if (type === 'terms') {
      this.modalTitle = 'Terms of Use';
      this.modalContent = this.sanitizer.bypassSecurityTrustHtml(
        `<iframe src="https://www.phzio.com/terms" width="100%" height="400px" style="border:0;"></iframe>`
      );
    }
    const modal = new (window as any).bootstrap.Modal(
      document.getElementById('policyModal')
    );
    modal.show();
  }


  clearSignature1(fieldName: string) {
    const ctx = this.contexts[fieldName];
    if (!ctx) return;
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    this.dynamicForm.get(fieldName)?.reset('');
    console.log(`Cleared signature for ${fieldName}`);
  }

  hasTooltip(option: any): boolean {
    return !!(option.tooltip && option.tooltip.trim());
  }

  formatYMD(dateStr: string): string {
    // Date-only: read the calendar day directly instead of shifting through UTC.
    return toApiDate(dateStr) ?? '';
  }

  isExecutiveHealthForm(): boolean {
    return (
      this.selectedResource?.typeOfForm
        ?.toLowerCase()
        .includes('executive health assessment') ||
      this.selectedResource?.typeOfForm
        ?.toLowerCase()
        .includes('executive health')
    );
  }
  
isExapForm(): boolean {
  return (
    this.selectedResource?.typeOfForm
      ?.toLowerCase()
      .includes('executive assistance') || false
  );
}

  isResourceModalOpen = false;


   private PROVINCE_MAP: Record<string, string> = {
  NFLD: 'NL',
  NF: 'NL',
  NEWFOUNDLAND: 'NL',
  LABRADOR: 'NL',
  QUEBEC: 'QC',
  ONTARIO: 'ON',
  ON: 'ON',
  ALBERTA: 'AB',
  BRITISHCOLUMBIA: 'BC',
  NOVASCOTIA: 'NS',
  MANITOBA: 'MB',
  SASKATCHEWAN: 'SK',
  PRINCEEDWARDISLAND: 'PE',
  NORTHWESTTERRITORIES: 'NT',
  NUNAVUT: 'NU',
  YUKON: 'YT'
};
private extractProvince(value: string): string {
  if (!value || typeof value !== 'string') return 'OTHER';
  // Strip any " - suffix" added for uniqueness before extracting province
  const cleanValue = value.replace(/\s*-\s*[^(]+$/, '').trim();
  const lastParen = cleanValue.match(/\(([^()]+)\)\s*$/);
  const inside = lastParen ? lastParen[1] : '';
  const source = inside || cleanValue;
  const parts = source.split(',').map((p) => p.trim()).filter(Boolean);
  let provincePart = parts.length ? parts[parts.length - 1] : source.trim();
  provincePart = provincePart.replace(/[^A-Za-z]/g, '').toUpperCase();
  if (!provincePart) return 'OTHER';
  if (this.PROVINCE_MAP[provincePart]) return this.PROVINCE_MAP[provincePart];
  const twoToThree = provincePart.match(/([A-Z]{2,3})$/);
  if (twoToThree) {
    const candidate = twoToThree[1];
    if (this.PROVINCE_MAP[candidate]) return this.PROVINCE_MAP[candidate];
    const allowed = ['ON','QC','BC','AB','MB','SK','NL','NS','PE','YT','NT','NU'];
    if (allowed.includes(candidate)) return candidate;
  }
  return provincePart || 'OTHER';
}

groupClinicsByProvince(options: any[]): Record<string, any[]> {
  const provinceGroups: Record<string, any[]> = {};

  options.forEach((opt) => {
    const province = this.extractProvince(opt?.value) || 'OTHER';
    if (!provinceGroups[province]) provinceGroups[province] = [];
    provinceGroups[province].push(opt);
  });
  Object.keys(provinceGroups).forEach((prov) => {
    provinceGroups[prov].sort((a, b) => {
      const nameA = (a.value || '').replace(/\s*\([^)]*\)$/, '').trim().toUpperCase();
      const nameB = (b.value || '').replace(/\s*\([^)]*\)$/, '').trim().toUpperCase();
      return nameA.localeCompare(nameB);
    });
  });
  this.groupedClinics = provinceGroups;
  this.groupedClinicsArray = this.buildSortedGroupArray(provinceGroups);

  return provinceGroups;
}

private buildSortedGroupArray(groups: Record<string, any[]>): { key: string; value: any[] }[] {
  const userProvinceRaw = (this.customerData?.province || '').toString().trim().toUpperCase();
  const userProvince = userProvinceRaw ? this.extractProvince(`(${userProvinceRaw})`) : '';
  const keys = Object.keys(groups);
  const normalizedKeys = Array.from(new Set(keys.map(k => (k || 'OTHER').toString().toUpperCase())));
  normalizedKeys.sort((a, b) => a.localeCompare(b));
  if (userProvince && normalizedKeys.includes(userProvince)) {
    const filtered = normalizedKeys.filter(k => k !== userProvince);
    return [{ key: userProvince, value: groups[userProvince] }, ...filtered.map(k => ({ key: k, value: groups[k] }))];
  }
  return normalizedKeys.map(k => ({ key: k, value: groups[k] }));
}

openResourceModal( resource: any,
coverageType?: 'self' | 'spouse' | 'both' | 'children' | string ) {
    this.isReginaLifeMode = false;
    console.log('Received Resource:', resource);
    console.log('Customer Data:', this.customerData);
    
     const typeKey = resource?.typeOfForm
    ?.trim()
    .toLowerCase();

  if (!typeKey) {
    return;
  }

const eligibilityForForm = this.eligibilityMap?.[typeKey];
if (eligibilityForForm) {
  const checkCoverage = coverageType || 'self';
  const entry = eligibilityForForm[checkCoverage] as any;
  if (entry && entry.canOrder === false) {
    Swal.fire({
      title: 'Not Eligible',
      text: this.buildEligibilityMessage(entry),
      confirmButtonText: 'OK',
    });
    return;
  }
}


    if (this.dynamicForm) {
      this.dynamicForm.reset();
    }
   this.selectedCoverage = [];
    this.currentCoverageType =coverageType ?? null;
    const isExapForm = resource?.typeOfForm?.toLowerCase().includes('executive assistance');
    this.hideCoverageDropdown = !!coverageType || isExapForm;
    this.createDynamicForm(resource.fields);

    setTimeout(() => {
      const coverageControl = this.dynamicForm.get('coverageType');
      if (coverageControl) {
        const coverageField = this.selectedResource.fields.find(
          (f) => f.name === 'coverageType'
        );
        const allCoverageValues =
          coverageField?.options?.map((opt: any) => opt.value) || [];
let coverageToSet: string[] = [];
console.log('coverageType param:', coverageType);
console.log('allCoverageValues:', allCoverageValues);
console.log('includes check:', allCoverageValues.includes(coverageType));

if (coverageType) {
  if (coverageType === 'both') {
    coverageToSet = allCoverageValues.filter((v: string) => v === 'self' || v === 'spouse');
  } else if (allCoverageValues.includes(coverageType)) {
    coverageToSet = [coverageType];
  }
  coverageControl.setValue(coverageToSet, { emitEvent: true });
  this.updateSelectedCoverageFields(coverageToSet);

  setTimeout(() => {
    coverageControl.disable({ emitEvent: false });
  }, 50);

  this.selectedCoverage = coverageToSet;
}
      }
    });

    const userProvince = this.customerData?.province || '';

    const sortedFields =
      resource.fields?.map((field: any) => {
        if (field.type === 'option-group' && field.options) {
          const optionsWithTooltip = field.options.map((opt: any) =>
            typeof opt === 'string' ? { value: opt } : opt
          );

          const getProvinceFromValue = (val: string): string | null => {
            if (!val) return null;

            // Extract the last parentheses content (e.g., "(St. John's, NFLD)")
            const match = val.match(/\(([^)]+)\)$/);
            if (!match) return null;

            const inside = match[1]; // e.g., "St. John's, NFLD"
            const parts = inside.split(',').map((p) => p.trim());

            // Province should be the last comma-separated part
            let province = parts[parts.length - 1];
            province = province
              .replace(/[^A-Za-z]/g, '') // remove any non-alphabet characters
              .toUpperCase(); // normalize to uppercase
            const fullMatch = province.match(/[A-Z]{2,5}$/);
            return fullMatch ? fullMatch[0] : province;
          };
          optionsWithTooltip.sort((a: any, b: any) => {
            const provinceA = getProvinceFromValue(a.value) || '';
            const provinceB = getProvinceFromValue(b.value) || '';

            if (provinceA === userProvince && provinceB !== userProvince)
              return -1;
            if (provinceB === userProvince && provinceA !== userProvince)
              return 1;
            if (provinceA !== provinceB)
              return provinceA.localeCompare(provinceB);
            return a.value.localeCompare(b.value);
          });

          field.options = optionsWithTooltip;

          console.log(
            'Sorted clinics based on user province:',
            userProvince,
            field.options
          );
        }
        return field;
      }) || [];
    this.selectedResource = {
      ...resource,
      typeOfForm: resource.typeOfForm || resource.title || 'Unknown Form',
      fields: sortedFields,
    };
    this.groupedClinics = {};
    const isExecutiveForm =
      resource?.typeOfForm
        ?.toLowerCase()
        .includes('executive health assessment') ||
      resource?.typeOfForm?.toLowerCase().includes('executive health');

    if (isExecutiveForm) {
      const clinicField = sortedFields.find(
        (f: any) => f.name === 'healthConcerns' && f.type === 'option-group'
      );

      if (clinicField && clinicField.options?.length) {
        this.groupedClinics = this.groupClinicsByProvince(clinicField.options);
        console.log(' USER PROVINCE:', this.customerData?.province);
        console.log(' GROUPED CLINICS:', this.groupedClinics);
        console.log(' GROUPED KEYS:', Object.keys(this.groupedClinics));
        console.log('Grouped Clinics:', this.groupedClinics);

        console.log('Sorted Grouped Clinics:', this.groupedClinics);
      } else {
        console.warn(' No clinic options found for Executive Health form.');
      }
    } else {
      console.log(
        'Non-Executive form detected (like EXAP). Grouped clinics cleared.'
      );
      this.groupedClinics = {};
    }
    this.modalTitle = resource.title || resource.typeOfForm || 'Bookings';
    console.log('ALL FIELDS:', JSON.stringify(this.selectedResource.fields, null, 2));
    this.createDynamicForm(this.selectedResource.fields);

const coverageField = this.selectedResource.fields.find(
  (f) => f.name === 'coverageType'
);
if (coverageField) {
  const dynamicOptions: any[] = [];
  const isExap = resource?.typeOfForm?.toLowerCase().includes('executive assistance');

  //  Self — use full name
  if (this.customerData?.firstName || this.customerData?.lastName) {
    const fullName = `${this.customerData.firstName || ''} ${
      this.customerData.lastName || ''
    }`.trim();
    dynamicOptions.push({
      value: 'self',
      label: `Self (${fullName})`,
    });
  }

  if (!isExap) {
    const spouse = this.customerData?.dependents?.spouseInfo;
    if (spouse?.firstName || spouse?.lastName) {
      const spouseFullName = `${spouse.firstName || ''} ${
        spouse.lastName || ''
      }`.trim();
      dynamicOptions.push({
        value: 'spouse',
        label: `Spouse (${spouseFullName})`,
      });
    }
const children = this.customerData?.dependents?.childrens || [];
    children.forEach((child: any, index: number) => {
      const childFullName = `${child.firstName || ''} ${child.lastName || ''}`.trim();
      dynamicOptions.push({
        value: `child_${child.id ?? index}`,
        label: `Child ${index + 1}${childFullName ? ' (' + childFullName + ')' : ''}`,
      });
    });
  }

coverageField.options = dynamicOptions;
  console.log(' Coverage options:', coverageField.options);
  this.selectedResource = { ...this.selectedResource };

  if (isExap) {
    setTimeout(() => {
      this.dynamicForm.get('coverageType')?.setValue(['self'], { emitEvent: true });
      this.currentCoverageType = 'self';
      this.uiCoverageLabels = ['Self'];
    }, 0);
  }
}
    this.dynamicForm
      .get('coverageType')
      ?.valueChanges.subscribe((coverage: string | string[]) => {
        if (!coverage) return;

        this.updateSelectedCoverageFields(coverage);
        const emailControl = this.dynamicForm.get('email');
        const hasSelf = Array.isArray(coverage)
          ? coverage.includes('self')
          : coverage === 'self';

        if (emailControl) {
          if (hasSelf) {
            emailControl.setValidators([Validators.required, Validators.email]);
          } else {
            emailControl.setValidators([Validators.email]);
          }
          emailControl.updateValueAndValidity({ emitEvent: false });
        }
      });

    this.signatureImage = '';
    console.log(
      ' Signature fields:',
      this.selectedResource?.fields?.filter((f) => f.type === 'signature')
    );
      this.ngZone.run(() => {
      this.isResourceModalOpen = true;
    });
    console.log('executivePlanOptionsApplicable:', this.customerData?.executivePlanOptionsApplicable);
console.log('customerData.customerPlans:', this.customerData?.customerPlans);
  }
  
  private buildEligibilityMessage(entry: any): string {
  if (!entry) return 'You are not eligible to place this order.';
  if (
    entry.message?.includes('company plan administrator') ||
    entry.message?.includes('admin@groupbenefitz.ca')
  ) {
    return entry.message;
  }
  if (
    entry.message?.toLowerCase().includes('premium') ||
    entry.message?.toLowerCase().includes('paid')
  ) {
    return 'Your premiums must be paid before any services can be booked';
  }
  return entry.message;
}



displayClinicName(value: string): string {
  if (!value) return '';
  // Extract any " - suffix" before removing province
  const suffixMatch = value.match(/\)\s*-\s*(.+)$/);
  const suffix = suffixMatch ? suffixMatch[1].trim() : '';
  // Remove (City, PROVINCE) and suffix
  let name = value
    .replace(/\s*\([^()]*,\s*(?:ON|QC|BC|AB|MB|NS|NL|NB|PE|SK|YT|NT|NU|NFLD)\)\s*(-\s*.+)?$/i, '')
    .replace(/\s*\(Vancouver\s*\(Island\),\s*BC\)\s*$/i, '')
    .trim();
  return name;
}


  private fixDobFromBackend(dob: string): string {
    // Was hand-splitting on '-' and assuming DD-MM-YYYY, which silently
    // produced nonsense for any other shape. The shared parser handles every
    // format the backend has ever sent.
    return toApiDate(dob) ?? '';
  }

  private updateSelectedCoverageFields(selected: string[] | string) {
    let sels = Array.isArray(selected) ? selected : selected ? [selected] : [];
    if (!sels.length) {
      return;
    }
    if (sels.includes('both')) {
      sels = Array.from(new Set([...sels, 'self', 'spouse']));
    }
    if (sels.includes('self') && this.customerData) {
      const self = this.customerData;
      this.dynamicForm.patchValue(
        {
          fullName: `${self.firstName || ''} ${self.lastName || ''}`.trim(),
          firstName: self.firstName || '',
          lastName: self.lastName || '',
          city: self.city || '',
          province: self.province || self.country || '',
          postalCode: self.postalCode || '',
          phone: self.primaryPhone || '',
          email: self.primaryEmail || '',
          dateOfBirth: this.fixDobFromBackend(self.dob),
          company: self.companyName || '',
          customerId: self.id || '',
          contractNumber:
         this.dynamicForm.getRawValue()?.contractNumber ||
            this.customerData?.additionalDetails?.services?.best_doctors
              ?.contract_id || '',
        },
        { emitEvent: false }
      );

      const mailingGroup = this.dynamicForm.get(
        'mailingAddress'
      ) as FormGroup | null;
      if (mailingGroup) {
        mailingGroup.patchValue(
          {
            streetAddress1: self.line1 || '',
            streetAddress2: self.line2 || '',
            city: self.city || '',
            state: self.province || '',
            zipCode: self.postalCode || '',
          },
          { emitEvent: false }
        );
      }
    }
    console.log('Form controls:', Object.keys(this.dynamicForm.controls));
    console.log(
      'Contract Number Value:',
      this.dynamicForm.get('contractNumber')?.value
    );
    if (sels.includes('spouse') && this.customerData?.dependents?.spouseInfo) {
      const spouse = this.customerData.dependents.spouseInfo;
      this.dynamicForm.patchValue(
        {
          spouseFirstName: spouse.firstName || '',
          spouseLastName: spouse.lastName || '',
          spouseDob: this.fixDobFromBackend(spouse.dob),
          spouseEmail: spouse.email || '',
          spouseGender: spouse.gender || '',
          spouseContractNumber:
            this.customerData?.additionalDetails?.services?.best_doctors
              ?.contract_id || '',
        },
        { emitEvent: false }

      );

      const mailingGroup = this.dynamicForm.get(
        'mailingAddress'
      ) as FormGroup | null;
      if (mailingGroup) {
        mailingGroup.patchValue(
          {
            streetAddress1: this.customerData.line1 || '',
            streetAddress2: this.customerData.line2 || '',
            city: this.customerData.city || '',
            state: this.customerData.province || '',
            zipCode: this.customerData.postalCode || '',
          },
          { emitEvent: false }
        );
      }
    }
// CHILDREN (support selecting e.g. 'child_3410', where 3410 is the child's real id)
const childSel = sels.find((s: any) => typeof s === 'string' && s.startsWith('child_'));
    console.log('sels:', sels);
    console.log('childSel:', childSel);
    if (childSel && this.customerData?.dependents?.childrens?.length) {
      const childIdStr = childSel.split('_')[1];
      const child = this.customerData.dependents.childrens.find(
        (c: any, idx: number) => String(c.id ?? idx) === childIdStr
      );
      console.log('childIdStr:', childIdStr);
      console.log('matched child:', child);
      if (child) {
        const childrenGroup = this.dynamicForm.get('children') as FormGroup | null;
        if (childrenGroup) {
          console.log('RAW child.dob:', child.dob, '| formatted:', this.formatYMD(child.dob));
          childrenGroup.patchValue({
            firstName: child.firstName || '',
            lastName: child.lastName || '',
            dob: this.formatYMD(child.dob),
            gender: child.gender || ''
          }, { emitEvent: false });
        } else {
           console.log('RAW child.dob (fallback branch):', child.dob, '| formatted:', this.formatYMD(child.dob));
          this.dynamicForm.patchValue({
            childFirstName: child.firstName || '',
            childLastName: child.lastName || '',
            childDob: this.formatYMD(child.dob),
            childGender: child.gender || ''
          }, { emitEvent: false });
        }

        const mailingGroup = this.dynamicForm.get('mailingAddress') as FormGroup | null;
        if (mailingGroup) {
          mailingGroup.patchValue({
            streetAddress1: this.customerData.line1 || '',
            streetAddress2: this.customerData.line2 || '',
            city: this.customerData.city || '',
            state: this.customerData.province || '',
            zipCode: this.customerData.postalCode || ''
          }, { emitEvent: false });
        }
      }
    }
 

const readonlyFields = [
      'firstName',
      'lastName',
      'fullName',
      'email',
      'dateOfBirth',
      'phone',
      'province',
      'postalCode',
      'company',
      'spouseFirstName',
      'spouseLastName',
      'spouseDob',
      'spouseEmail',
      'spouseGender',
      'zipCode',
      'childFirstName',
      'childLastName',
      'childDob',
      'childGender',
    ];
    const mailingReadonlyFields = [
      'streetAddress1',
      'streetAddress2',
      'city',
      'state',
      'zipCode',
    ];

    readonlyFields.forEach((key) => {
      const control = this.dynamicForm.get(key);
      const value = control?.value;
      if (control) {
        if (value !== null && value !== undefined && value !== '') {
          control.disable({ emitEvent: false });
        } else {
          control.enable({ emitEvent: false });
        }
      }
    });
    const mailingGroup = this.dynamicForm.get(
      'mailingAddress'
    ) as FormGroup | null;
    if (mailingGroup) {
      Object.keys(mailingGroup.controls).forEach((key) => {
        const control = mailingGroup.get(key);
        if (!control) return;

        const value = control.value;

        if (key === 'streetAddress2') {
          control.enable({ emitEvent: false });
          control.clearValidators();
          control.updateValueAndValidity({ emitEvent: false });
          return;
        }
        if (value !== null && value !== undefined && value !== '') {
          control.disable({ emitEvent: false });
        } else {
          control.enable({ emitEvent: false });
        }

        control.updateValueAndValidity({ emitEvent: false });
      });
    }
    console.log('Form controls:', Object.keys(this.dynamicForm.controls));
    console.log(
      'Contract Number Value:',
      this.dynamicForm.get('contractNumber')?.value
    );
  }

  get childrenArray(): FormArray {
    return this.dynamicForm.get('childrens') as FormArray;
  }

  redirectToMap(address: string) {
    if (!address) return;
    const url = `https://www.google.com/maps?q=${encodeURIComponent(
      address
    )}&output=embed`;
    this.selectedMapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    $('#resourceModal').hide();
    $('#mapModal').show().addClass('show').css('display', 'block');
    $('body').addClass('modal-open');
    $('#mapModal').one('click', '[data-bs-dismiss="modal"], .btn-close', () => {
      $('#mapModal').hide().removeClass('show').css('display', 'none');
      $('#resourceModal').show();
      $('body').removeClass('modal-open');
    });
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseDown(event: MouseEvent | TouchEvent, fieldName: string) {
    event.preventDefault();
    const ctx = this.contexts[fieldName];
    if (!ctx) return;
    this.drawing[fieldName] = true;
    ctx.beginPath();

    const { x, y } = this.getPosition(event, ctx.canvas);
    ctx.moveTo(x, y);
  }

  onMouseMove(event: MouseEvent | TouchEvent, fieldName: string) {
    const ctx = this.contexts[fieldName];
    if (!ctx || !this.drawing[fieldName]) return;

    const { x, y } = this.getPosition(event, ctx.canvas);
    if (
      x < 0 ||
      y < 0 ||
      x > ctx.canvas.clientWidth ||
      y > ctx.canvas.clientHeight
    ) {
      return;
    }
    ctx.lineTo(x, y);
    ctx.stroke();
  }
private isCanvasBlank(canvas: HTMLCanvasElement): boolean {
  const ctx = canvas.getContext('2d');
  if (!ctx) return true;
  const pixelBuffer = new Uint32Array(
    ctx.getImageData(0, 0, canvas.width, canvas.height).data.buffer
  );
  return !pixelBuffer.some(color => color !== 0);
}
onMouseUp(fieldName: string) {
  if (!this.drawing[fieldName]) return;
  this.drawing[fieldName] = false;

  const ctx = this.contexts[fieldName];
  if (!ctx) return;

  if (this.isCanvasBlank(ctx.canvas)) {
    console.log(`Signature for ${fieldName} is blank — not saving`);
    const control = this.dynamicForm.get(fieldName);
    if (control) {
      control.setValue('');
      control.markAsTouched();
      control.updateValueAndValidity();
    }
    return;
  }

  const dataURL = ctx.canvas.toDataURL('image/png');
  const control = this.dynamicForm.get(fieldName);
  if (control) {
    control.setValue(dataURL);
    control.markAsTouched();
    control.updateValueAndValidity();
    console.log(` Saved signature for ${fieldName}`);
  }
}

  private getPosition(
    event: MouseEvent | TouchEvent,
    canvas: HTMLCanvasElement
  ) {
    const rect = canvas.getBoundingClientRect();
    const clientX =
      event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
    const clientY =
      event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
    return { x: clientX - rect.left, y: clientY - rect.top };
  }

  createDynamicForm(fields: any[]): FormGroup {
    const group: any = {};

    fields.forEach((field) => {
      const validators: ValidatorFn[] = [];
      if (field.type === 'group' && field.fields) {
        group[field.name] = this.createDynamicForm(field.fields);
        return;
      }
      if (field.type === 'email') validators.push(Validators.email);
      if (field.type === 'option-group' || field.type === 'select')
        validators.push(Validators.required);
      if (field.minLength)
        validators.push(Validators.minLength(field.minLength));
      if (field.maxLength)
        validators.push(Validators.maxLength(field.maxLength));
      if (field.name === 'contractNumber') {
        validators.push(Validators.pattern(/^[0-9]*$/)); 
        validators.push(Validators.maxLength(12));
      }

      if (field.type === 'signature') {
        validators.push(Validators.required);
      }
      const initialValue = field.value ?? field.defaultValue ?? '';
      const control = new FormControl(initialValue, validators);
      if (this.customerData) {
        const customerValue =
          this.customerData[field.name] ||
          this.customerData?.dependents?.spouseInfo?.[field.name] ||
          this.customerData?.additionalDetails?.[field.name] ||
          null;
        if (
          customerValue !== null &&
          customerValue !== undefined &&
          customerValue !== ''
        ) {
          control.setValue(customerValue);
          control.disable({ emitEvent: false });
        } else {
          control.enable({ emitEvent: false });
        }
      }

      if (field.type === 'signature') {
        control.enable({ emitEvent: false });
        control.setValue('');
      }

      group[field.name] = control;
    });

    const formGroup = this.formBuilder.group(group);
    this.dynamicForm = formGroup;

    if (!formGroup.get('coverageType')) {
      formGroup.addControl(
        'coverageType',
        new FormControl([], Validators.required)
      );
    }

    console.log('Form Controls:', Object.keys(this.dynamicForm.controls));
    return formGroup;
  }

  onConsentLabelClick(event: MouseEvent): void {
    const target = event.target as HTMLElement | null;
    if (!target) return;

    if (target.tagName === 'INPUT' || !!target.closest('a')) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }


  isFirstFieldOf(type: 'self' | 'spouse' | 'children', index: number): boolean {
    const fields = this.selectedResource?.fields || [];
    const current = fields[index];
    if (!current?.showIf?.value || current.showIf.value !== type) return false;
    for (let i = 0; i < index; i++) {
      if (fields[i]?.showIf?.value === type) return false;
    }
    return true;
  }


  isMailingAddress(field: any): boolean {
  return field.type === 'group' && field.name === 'mailingAddress';
}

shouldShowMailingAddress(): boolean {
  const coverage = this.dynamicForm.get('coverageType')?.value;
  return coverage?.includes('self') || coverage?.includes('spouse');
}

  onSubmit() {
    const typeOfForm = this.selectedResource?.typeOfForm?.toLowerCase();

    const normalized = typeOfForm?.toLowerCase().replace(/\s+/g, '');
   
    console.log('Submit triggered');
    this.dynamicForm.markAllAsTouched();

    const coverage = this.dynamicForm.get('coverageType')?.value || [];
 const rawCoverage = this.currentCoverageType ??
  (Array.isArray(coverage)
    ? coverage.length > 1
      ? 'both'
      : coverage[0]
    : coverage);

const resolvedCoverageType: any = typeof rawCoverage === 'string' && rawCoverage.startsWith('child_')
  ? 'children'
  : rawCoverage;
    console.log(' Final Payload:', '3');

    const hasSelf = Array.isArray(coverage)
      ? coverage.includes('self')
      : coverage === 'self';
    const hasSpouse = Array.isArray(coverage)
      ? coverage.includes('spouse')
      : coverage === 'spouse';

const hasChildCoverage = Array.isArray(coverage)
  ? coverage.some((c: any) => typeof c === 'string' && c.startsWith('child_'))
  : typeof coverage === 'string' && coverage.startsWith('child_');

const signatureFields = ['signature', 'spouseSignature'];
signatureFields.forEach((sig) => {
  const sigControl = this.dynamicForm.get(sig);
  if (!sigControl) return;
  const isSelfSig = sig === 'signature';
  const isSpouseSig = sig === 'spouseSignature';
  const shouldValidate =
    (isSelfSig && (hasSelf || hasChildCoverage)) || (isSpouseSig && hasSpouse);
  if (shouldValidate) {
    if (!sigControl.value || sigControl.value.trim() === '') {
      sigControl.setErrors({ required: true });
      sigControl.markAsTouched();
    }
  } else {
    sigControl.setErrors(null);
  }
});
    console.log(' Final Payload:', '4');
    if (!coverage || coverage.length === 0) {
      Swal.fire({
        title: 'Missing Selection',
        text: 'Please select coverage before submitting your request.',
        confirmButtonText: 'OK',
      });
      return;
    }
    console.log(' Final Payload:', '5');
    if (this.dynamicForm.invalid) {
      const invalidFields: string[] = [];
      Object.keys(this.dynamicForm.controls).forEach((key) => {
        const control = this.dynamicForm.get(key);
        if (control && control.invalid) {
          const fieldMeta = this.selectedResource?.fields?.find(
            (f: any) => f.name === key
          );
          let label = fieldMeta?.sublabel || fieldMeta?.label || key;

          if (key === 'healthConcerns') label = 'Clinic Selection';
          if (key === 'signature') label = 'Member Signature';
          if (key === 'spouseSignature') label = 'Spouse Signature';
          if (key === 'coverageType') label = 'Booking For (Self/Spouse)';
          if (key === 'consent') label = 'Member Consent';
          if (key === 'spouseConsent') label = 'Spouse Consent';

          if (label.length > 40) label = label.substring(0, 40) + '...';
          invalidFields.push(label);
        }
      });

      Swal.fire({
        title: 'Missing Information',
        html: `
        <p>The following fields are missing:</p>
        <ul style="text-align: left; max-height: 200px; overflow-y: auto;">
          ${invalidFields.map((f) => `<li>${f}</li>`).join('')}
        </ul>
      `,
        confirmButtonText: 'OK',
      });
      return;
    }
    console.log(' Final Payload:', '6');

    const formData = this.dynamicForm.getRawValue();
    const formatYMD = (d: any) => toApiDate(d);

    const dependents: any = {};
    console.log(' Final Payload:', '7');

    if (
      formData.coverageType === 'spouse' ||
      formData.coverageType === 'children'
    ) {
      dependents.spouseInfo =
        formData.coverageType === 'spouse'
          ? {
              firstName: formData.spouseFirstName || '',
              lastName: formData.spouseLastName || '',
              dob: formatYMD(formData.spouseDob),
              email: formData.spouseEmail || '',
              gender: formData.spouseGender || '',
              relationType: 'SPOUSE',
              status: 'PENDING',
            }
          : undefined;
      dependents.childrens = [];
    }

    console.log(' Final Payload:', '8');
const { spouseContractNumber: _spouseContract, dob, ...restFormData } = formData;
const payload: any = {
  ...restFormData,
additionalNotes: formData.additionalNotes?.trim() ?? '',

      typeOfForm:
        this.selectedResource?.typeOfForm ||
        this.selectedResource?.title ||
        'Unknown Form',
      customerId: this.customerData.id,
      company: formData.company || this.customerData.companyName || '',
      dateOfBirth: formatYMD(formData.dob || this.customerData?.dob),
      coverageType: resolvedCoverageType,

contractNumber: formData.contractNumber || formData.spouseContractNumber || '',
      status: 'pending',
      consent: !!formData.consent,
      signature: formData.signature,
      streetAddress1: this.customerData.line1 || '',
      streetAddress2: this.customerData.line2 || '',
      state: this.customerData.province || '',
      zipCode: this.customerData.postalCode || '',
    };

    console.log(' Final Payload:', payload);

    if (hasSpouse) {
      payload.spouseFirstName = formData.spouseFirstName || '';
      payload.spouseLastName = formData.spouseLastName || '';
      payload.spouseDob = formatYMD(formData.spouseDob);
      payload.spouseEmail = formData.spouseEmail || '';
      payload.spouseGender = formData.spouseGender || '';
      payload.spouseConsent = !!formData.spouseConsent;
      payload.spouseSignature = formData.spouseSignature || '';
    }

    console.log(' Final Payload end:', payload);

   Object.keys(payload).forEach((key) => {
  const value = payload[key];

  if (
    value === '' ||
    value === null ||
    value === undefined ||
    (typeof value === 'string' && value.trim() === '')
  ) {
    delete payload[key];
  }
});

  this.isSubmitting = true;
   this.closeResourceModal();
   this.showFullPageLoader = true;
   
// Regina Life — charge payment first before saving booking
if (this.isReginaLifeMode) {
  const optionDeductibles: any = {
    'Option A': 4000,
    'Option B': 6000,
    'Option C': 11000,
  };
  const selectedOption = payload.screeningOption || 'Option A';
  const deductible = optionDeductibles[selectedOption] || 4000;

  Swal.fire({
    title: 'Payment Confirmation',
    html: `
      <p>You have selected <strong>${selectedOption}</strong>.</p>
      <p>A deductible of <strong>$${deductible.toLocaleString()}</strong> will be charged to your card on file.</p>
      <p>Do you want to proceed?</p>
    `,
    showCancelButton: true,
    confirmButtonText: 'Yes, proceed',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#1a2e4a',
  }).then((result) => {
    if (!result.isConfirmed) {
      this.isSubmitting = false;
      return;
    }

    // Charge the card
 this.http.post(this.apiUrl + '/bookings/regina-life/charge', {
  customerId: this.customerData.id,
  customerProfileId: this.customerData.authorizenetCustomerId,
  paymentProfileId: this.customerData.authorizenetPaymentId,
  amount: deductible,
  screeningOption: selectedOption,
}).subscribe({
  next: (chargeRes: any) => {
    payload.transactionId = chargeRes.transactionId;
    payload.deductibleAmount = deductible;
this.showReginaLifeConsent((signature: string) => {
  payload.reginaConsent = true;
  payload.reginaSignature = signature;
  this.http.post(this.apiUrl + '/bookings', payload).subscribe({
    next: (res) => {
      this.isSubmitting = false;
      this.isReginaLifeMode = false;
      this.closeResourceModal();
      Swal.fire({
        title: 'Booking Confirmed',
        html: `<p>Thank you for your request. If you have any questions, please contact us at <a href="mailto:admin@groupbenefitz.ca">admin@groupbenefitz.ca</a></p>`,
        confirmButtonText: 'OK',
        confirmButtonColor: '#1a2e4a',
      });
      this.bookingCreated.emit({
        customerId: this.customerData.id,
        typeOfForm: this.selectedResource?.typeOfForm,
        coverageType: resolvedCoverageType as 'self' | 'spouse' | 'both',
      });
    },
    error: (err) => {
      this.isSubmitting = false;
      Swal.fire('Error', err?.error?.message || 'Failed to save booking.', 'error');
    }
  });
});
  },
error: (err) => {
    this.isSubmitting = false;
    Swal.fire({
      title: 'Payment Failed',
      html: `<p>Your payment could not be processed. Please contact us at <a href="mailto:admin@groupbenefitz.ca">admin@groupbenefitz.ca</a> for assistance.</p>`,
      confirmButtonText: 'OK',
      confirmButtonColor: '#1a2e4a',
    });
  }
});
  });
  return;
}
this.http.post(this.apiUrl + '/bookings', payload).subscribe({
    
      next: (res) => {
         this.isSubmitting = false;
         this.showFullPageLoader = false;

  console.log('Booking saved successfully', res);

  const redirectInfo = this.getExternalRedirectInfo(normalized);

  //  CASE 1: External partner (MSK360 / RXFood)
  if (redirectInfo) {
      this.bookingCreated.emit({
    customerId: this.customerData.id,
    typeOfForm: this.selectedResource?.typeOfForm,
    coverageType: resolvedCoverageType,
  });

Swal.fire({
  title: 'Request Received',
  html: `
    <p>Your request has been received successfully.</p>
    <p>
      You’ll now be redirected to our partner
      <strong>${redirectInfo.partner}</strong>
      to complete your registration.
    </p>
    <p style="font-size:13px;color:#666;">
      If you don’t complete the registration, your request will remain pending.
    </p>
  `,
  showCancelButton: true,
  showDenyButton: false,
  confirmButtonText: 'Proceed',
  cancelButtonText: 'Cancel',
  allowOutsideClick: false,
    customClass: {
    confirmButton: 'gb-swal-confirm'
  }

}).then((result) => {

  if (result.isConfirmed) {
    window.open(redirectInfo.url, '_blank');
  }
  this.isReginaLifeMode = false;
  this.closeResourceModal();
  
});
return;

  }


this.closeResourceModal();

const memberEmail = this.customerData?.email || this.customerData?.user?.username || '';
Swal.fire({
  title: 'Success',
  html: `
    <p>
      Your request has been successfully processed and an email with the steps to be followed has been sent to 
      <a href="mailto:${memberEmail}" style="color:#007bff; text-decoration:none;">
        ${memberEmail}
      </a>. 
      Please contact your broker should you need any clarifications.
    </p>
  `,
  confirmButtonText: 'OK',
}).then(() => {
  this.closeResourceModal();
});
  this.bookingCreated.emit({
    customerId: this.customerData.id,
    typeOfForm: this.selectedResource?.typeOfForm,
    coverageType: resolvedCoverageType,
  });
},

      error: (err) => {
        this.isSubmitting = false;
        this.showFullPageLoader = false;
        console.error(' Error saving booking:', err);
        Swal.fire({
          title: 'Error',
          text:
            err.error?.message ||
            'Failed to save booking. Please try again later.',
        });
      },
    });


  }


  

  confirmRedirect() {
  if (!this.redirectUrl) return;

  this.isExternalRedirect = false;
  window.open(this.redirectUrl, '_blank');
}

showReginaLifeConsent(onAgreed: (signature: string) => void) {
  Swal.fire({
    title: 'Regina Life Consent & Agreement',
    html: `
      <div style="text-align:left; max-height:400px; overflow-y:auto; font-size:13px; padding: 0 10px;">
        <h6 style="font-weight:bold; margin-top:10px;">A) Consent to Health Screening, Treatment, and Health Optimization</h6>
        <p>I understand and agree with the rationale of the treatment and/or screening and health optimization plan being proposed to me. I understand and accept that screening and health optimization tests may be ordered for me in advance of interacting with RegenaLife care providers as part of routine RegenaLife procedure.</p>
        <p>I acknowledge that the relevant risks, side effects and therapeutic efficacy of each screening and health optimization procedure or intervention have been provided to me, and I consent to treatment and/or screening and health optimization plans presented to me.</p>
        <p>I understand and consent to RegenaLife engaging with third-party screening and therapeutic service providers, in Canada, the US, and certain European countries as necessary, on my behalf.</p>
        <hr/>
        <h6 style="font-weight:bold;">B) PHIPA Privacy Notice</h6>
        <p>RegenaLife is committed to the strictest standards of client healthcare information privacy. We are required by law to maintain the privacy of protected health information, which includes any identifiable information that relates to your physical or mental health, the health care you have received, or payment for your health care.</p>
        <p>We may use or disclose your protected health information for purposes of screening, treatment, payment and health care operations as provided by law.</p>
        <hr/>
        <h6 style="font-weight:bold;">C) General Waiver & Release and Limited Disclosure</h6>
        <p>You release and forever discharge RegenaLife (1450255 Canada LTD) and its affiliates, successors, officers, employees, representatives, partners, and agents from any and all claims arising out of or relating to services rendered.</p>
        <p>You grant RegenaLife authorization to share medical and/or personal information with third-party medical providers, physicians and practitioners in order to fulfill its duties related to the provision of services.</p>
        <p>You acknowledge that RegenaLife services are strictly limited to medical screening for informational purposes only and are NOT a replacement for your primary care, acute medical care, or emergency care providers.</p>
        <hr/>
        <h6 style="font-weight:bold;">D) Client Consent for E-Mail Communications</h6>
        <p>Your care provider may communicate with you using e-mail. You understand that the security of e-mail messages is not guaranteed and messages may be seen by others. Do not use e-mail in an emergency as it can be delayed.</p>
        <hr/>
<div style="margin-top:15px;">
  <div id="reginaConsentToggle" 
    onclick="this.classList.toggle('agreed'); document.getElementById('reginaConsentCheck').value = this.classList.contains('agreed') ? 'yes' : '';"
    style="display:flex; align-items:flex-start; gap:10px; cursor:pointer; padding:10px; border:1px solid #ddd; border-radius:6px; background:#f9f9f9;">
    <div id="reginaConsentBox" style="min-width:20px; width:20px; height:20px; border:2px solid #1a2e4a; border-radius:3px; display:flex; align-items:center; justify-content:center; background:white;">
      <span id="reginaCheckMark" style="display:none; color:#1a2e4a; font-weight:bold;">✓</span>
    </div>
    <span style="font-size:13px;">I have read and agree to all of the above consent agreements (A, B, C, D) and authorize RegenaLife to proceed with my health screening.</span>
  </div>
  <input type="hidden" id="reginaConsentCheck" value=""/>
</div>
        <div style="margin-top:15px;">
          <label style="font-weight:bold; font-size:12px;">E-Signature (type your full name):</label>
          <input type="text" id="reginaSignatureInput"
            placeholder="Type your full name as signature"
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px; margin-top:5px; font-size:13px;"/>
        </div>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'I Agree & Submit',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#1a2e4a',
    width: '650px',
didOpen: () => {
  const toggle = document.getElementById('reginaConsentToggle');
  const checkMark = document.getElementById('reginaCheckMark');
  const hiddenInput = document.getElementById('reginaConsentCheck') as HTMLInputElement;
  if (toggle && checkMark && hiddenInput) {
    toggle.addEventListener('click', () => {
      const isAgreed = hiddenInput.value === 'yes';
      hiddenInput.value = isAgreed ? '' : 'yes';
      checkMark.style.display = isAgreed ? 'none' : 'block';
      (document.getElementById('reginaConsentBox') as HTMLElement).style.background = isAgreed ? 'white' : '#e8f0fe';
    });
  }
},
preConfirm: () => {
  const checked = (document.getElementById('reginaConsentCheck') as HTMLInputElement)?.value === 'yes';
  const signature = (document.getElementById('reginaSignatureInput') as HTMLInputElement)?.value?.trim();
  if (!checked) {
    Swal.showValidationMessage('Please check the consent checkbox to proceed.');
    return false;
  }
  if (!signature) {
    Swal.showValidationMessage('Please type your full name as e-signature.');
    return false;
  }
  return { signature };
}
  }).then((result) => {
    if (!result.isConfirmed) return;
    onAgreed(result.value?.signature);
  });
}
onClinicOptionSelected(option: any) {
  const billingKey = this.resolveBillingKey(option);
  if (!billingKey) return; // normal clinic — no popup, no charge

  this.http.get(this.apiUrl + '/billing-options/' + billingKey).subscribe({
    next: (config: any) => {
      if (!config || !config.options?.length) return;
      this.openGenericBillingPopup(config);
    },
    error: (err) => {
      console.log('Failed to load billing options:', err);
    },
  });
}

// TEMP: once assessment_forms_templates has a real `billingKey` field on
// each clinic option, this becomes `return option.billingKey;`
private resolveBillingKey(option: any): string | null {
  if (option.billingKey) return option.billingKey; // future DB-driven path
  const val = (option.value || '').toLowerCase();
  if (val.includes('medcan')) return 'medcan-galleri';
  if (val.includes('regenalife')) return 'regenalife-deductible';
  return null;
}

openGenericBillingPopup(config: any) {
  if (config.popupType === 'CONFIRM_UPSELL') {
    this.renderConfirmUpsellPopup(config);
  } else if (config.popupType === 'SELECT_OPTION') {
    this.renderSelectOptionPopup(config);
  }
}

private renderConfirmUpsellPopup(config: any) {
  const option = config.options[0];
const body = `Would you like to add the <strong>${option.label}</strong> for <strong>$${option.amount.toLocaleString()}</strong>? This will be charged to your card on file.`;

  Swal.fire({
    title: config.popupTitle,
    html: `<p>${body}</p>`,
    showCancelButton: true,
    confirmButtonText: 'Yes, add it',
    cancelButtonText: 'No, thanks',
    confirmButtonColor: '#1a2e4a',
  }).then((result) => {
    if (result.isConfirmed) {
      this.proceedToChargeOrConsent(config, option);
    }
  });
}

private renderSelectOptionPopup(config: any) {
  Swal.fire({
    title: config.popupTitle,
    html: `
      <div style="text-align:left;">
        ${config.options.map((opt: any, i: number) => `
          <div style="display:flex; align-items:center; gap:8px; margin-bottom:10px;">
            <input
              type="radio"
              name="billing-option"
              id="billing-option-${i}"
              value="${opt.label}"
              style="appearance: auto; -webkit-appearance: radio; width: 16px; height: 16px; margin: 0; flex-shrink: 0; cursor: pointer;"
            />
            <label for="billing-option-${i}" style="cursor:pointer; margin:0;">
              ${opt.label} — Deductible: $${opt.amount.toLocaleString()}
            </label>
          </div>
        `).join('')}
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Continue',
    confirmButtonColor: '#1a2e4a',
    preConfirm: () => {
      const selectedLabel = (document.querySelector('input[name="billing-option"]:checked') as HTMLInputElement)?.value;
      if (!selectedLabel) {
        Swal.showValidationMessage('Please select an option to continue.');
        return false;
      }
      return selectedLabel;
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const selectedOption = config.options.find((o: any) => o.label === result.value);
      this.proceedToChargeOrConsent(config, selectedOption);
    }
  });
}

private proceedToChargeOrConsent(config: any, selectedOption: any) {
  if (config.consentTemplateKey) {
    this.showReginaLifeConsent((signature: string) => {
      this.renderPaymentMethodChoice(config, selectedOption);   
    });
  } else {
    this.renderPaymentMethodChoice(config, selectedOption);      
  }
}
private renderPaymentMethodChoice(config: any, selectedOption: any) {
  Swal.fire({
    title: 'Payment Method',
    html: `
      <div style="text-align:left;">
        <label style="display:flex; align-items:center; gap:8px; margin-bottom:10px; cursor:pointer;">
          <input type="radio" name="payment-method-choice" value="onfile" checked
            style="appearance: auto; -webkit-appearance: radio; width:16px; height:16px; margin:0;" />
          <span>Use payment method on file</span>
        </label>
        <label style="display:flex; align-items:center; gap:8px; cursor:pointer;">
          <input type="radio" name="payment-method-choice" value="new"
            style="appearance: auto; -webkit-appearance: radio; width:16px; height:16px; margin:0;" />
          <span>Use a new card</span>
        </label>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Continue',
    confirmButtonColor: '#1a2e4a',
    preConfirm: () => {
      return (document.querySelector('input[name="payment-method-choice"]:checked') as HTMLInputElement)?.value;
    },
  }).then((result) => {
    if (!result.isConfirmed) return;
    if (result.value === 'new') {
      this.renderNewCardForm(config, selectedOption);
    } else {
      this.chargeSelectedOption(config, selectedOption);
    }
  });
}

private renderNewCardForm(config: any, selectedOption: any) {
  const months = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'));
  const years = Array.from({ length: 10 }, (_, i) => String(new Date().getFullYear() + i));

  Swal.fire({
    title: 'Enter Card Details',
    html: `
      <div style="text-align:left;">
        <label style="font-size:12px; font-weight:bold;">Card Number</label>
        <input id="newCardNumber" type="text" maxlength="19" placeholder="1234 5678 9012 3456"
          style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px; margin:5px 0 12px; font-size:13px;" />

        <label style="font-size:12px; font-weight:bold;">Expiration</label>
        <div style="display:flex; gap:8px; margin:5px 0;">
          <select id="newCardExpMonth" style="flex:1; padding:8px; border:1px solid #ccc; border-radius:4px;">
            ${months.map(m => `<option value="${m}">${m}</option>`).join('')}
          </select>
          <select id="newCardExpYear" style="flex:1; padding:8px; border:1px solid #ccc; border-radius:4px;">
            ${years.map(y => `<option value="${y}">${y}</option>`).join('')}
          </select>
        </div>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Pay Now',
    confirmButtonColor: '#1a2e4a',
    preConfirm: () => {
      const cardNumber = (document.getElementById('newCardNumber') as HTMLInputElement)?.value?.trim();
      const expMonth = (document.getElementById('newCardExpMonth') as HTMLSelectElement)?.value;
      const expYear = (document.getElementById('newCardExpYear') as HTMLSelectElement)?.value;

      const digitsOnly = cardNumber?.replace(/\s/g, '') ?? '';
      if (!/^\d{13,19}$/.test(digitsOnly)) {
        Swal.showValidationMessage('Please enter a valid card number.');
        return false;
      }
      return { cardNumber: digitsOnly, expMonth, expYear };
    },
  }).then((result) => {
    if (!result.isConfirmed) return;
    this.chargeWithNewCard(config, selectedOption, result.value.cardNumber, result.value.expMonth, result.value.expYear);
  });
}

private chargeSelectedOption(config: any, selectedOption: any) {
  this.showFullPageLoader = true;

  const payload: any = {
    customerId: this.customerData.id,
    billingKey: config.billingKey,
  };
  if (config.options.length > 1) {
    payload.selectedOptionLabel = selectedOption.label;
  }

  this.http.post(this.apiUrl + '/bookings/adhoc-charge', payload).subscribe({
next: (res: any) => {
  this.showFullPageLoader = false;
  const isManual = res?.data?.manualProcessing === true;
  Swal.fire({
    title: isManual ? 'Request Received' : 'Added',
    html: isManual
      ? `<p>Your request has been received. Since your payment method is on file as PAD/ACH, our team will process your payment manually and follow up with you shortly.</p>`
      : `<p>Your request has been processed. A confirmation email with your invoice has been sent to you.</p>`,
    confirmButtonText: 'OK',
    confirmButtonColor: '#1a2e4a',
  });
},
error: (err) => {
  this.showFullPageLoader = false;
  const backendMessage = err?.error?.message;
  Swal.fire({
    title: 'Unable to Process',
    html: `<p>${backendMessage || 'Unable to process payment. Please contact us at <a href="mailto:admin@groupbenefitz.ca">admin@groupbenefitz.ca</a>.'}</p>`,
    confirmButtonText: 'OK',
    confirmButtonColor: '#1a2e4a',
  });
},
  });
}
chargeWithNewCard(config: any, selectedOption: any, cardNumber: string, expirationMonth: string, expirationYear: string) {
  this.showFullPageLoader = true;

  const invoiceNumber = `TEMP-${Date.now()}`;

  const surchargeApplicable = true;
  const surchargePercentage = 2.5;
  const surchargeAmount = +(selectedOption.amount * (surchargePercentage / 100)).toFixed(2);

  const object = {
    customerEmail: this.customerData.contactInformations?.[0]?.primaryEmail || this.customerData.email,
    referenceId: invoiceNumber,
    amount: selectedOption.amount,
    cardNumber: cardNumber.replaceAll(' ', ''),
    expirationDate: `${expirationMonth}/${expirationYear}`,
    currencyCode: 'CAD',
    invoiceNumber,
    description: `Adhoc payment - ${selectedOption.lineItemLabel} for customer #${this.customerData.id}`,
    surchargeApplicable,
    surchargeAmount,
    surchargeDescription: `Surcharge percentage ${surchargePercentage}%`,
  };

  this.http.post(this.authorizeApiUrl + 'api/authorize-net/one-time-payment', object).subscribe({
    next: (response: any) => {
      this.showFullPageLoader = false;
      this.recordNewCardPayment(config, selectedOption, response.transactionId, invoiceNumber, response.status === 'Captured');
    },
    error: () => {
      this.showFullPageLoader = false;
      Swal.fire({
        title: 'Payment Failed',
        html: `<p>Unable to process payment. Please contact us at <a href="mailto:admin@groupbenefitz.ca">admin@groupbenefitz.ca</a>.</p>`,
        confirmButtonText: 'OK',
        confirmButtonColor: '#1a2e4a',
      });
    },
  });
}
private recordNewCardPayment(config: any, selectedOption: any, transactionId: string, invoiceNumber: string, success: boolean) {
  this.http.post(this.apiUrl + '/bookings/record-newcard-charge', {
    customerId: this.customerData.id,
    billingKey: config.billingKey,
    selectedOptionLabel: selectedOption.label,
    transactionId,
    invoiceNumber,
    success,
  }).subscribe({
    next: () => {
      Swal.fire({
        title: success ? 'Added' : 'Payment Failed',
        html: success
          ? `<p>Your request has been processed. A confirmation email with your invoice has been sent to you.</p>`
          : `<p>Payment could not be completed. Please contact admin@groupbenefitz.ca.</p>`,
        confirmButtonText: 'OK',
        confirmButtonColor: '#1a2e4a',
      });
    },
  });
}
  private getExternalRedirectInfo(normalized: string): {
  url: string;
  partner: string;
} | null {
  if (normalized.includes('nutrition') && normalized.includes('diabetes')) {
    return {
      url: 'https://rxfood.com/register/groupbenefitz-en',
      partner: 'RXFood',
    };
  }

  if (normalized.includes('msk360') || normalized.includes('phizio')) {
    return {
      url: 'https://app.msk360.net/start/groupbenefitz',
      partner: 'MSK360',
    };
  }

  return null; 
}

isClinicSelected(fieldName: string, value: string): boolean {
    return this.dynamicForm.get(fieldName)?.value === value;
}

getCityOnly(value: string): string {
  if (!value) return '';
  if (value.toLowerCase().includes('vancouver (island)')) return 'Vancouver (Island)';
  // Strip suffix like " - Bay Street" before extracting city
  const cleanValue = value.replace(/\s*-\s*[^(]+$/, '').trim();
  // Match the LAST occurrence of (City, PROVINCE)
  const matches = [...cleanValue.matchAll(/\(([^()]+),\s*[A-Z]{2,4}\)/g)];
  if (matches.length > 0) {
    const lastMatch = matches[matches.length - 1];
    return lastMatch[1].trim();
  }
  return '';
}
  closeResourceModal() {
    this.isResourceModalOpen = false;
    document.body.classList.remove('modal-open');
  }


  private findFirstInvalidControl(formGroup: FormGroup): string | null {
    for (const key of Object.keys(formGroup.controls)) {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        const nestedInvalid = this.findFirstInvalidControl(control);
        if (nestedInvalid) return nestedInvalid;
      } else if (control?.invalid) {
        return key;
      }
    }
    return null;
  }
}